/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-controls-skip-forward-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M17.5 2.5h1.25v15H17.5v-15zm-14.375 15a.625.625 0 01-.625-.625V3.125a.625.625 0 01.938-.54l11.875 6.874a.625.625 0 010 1.082L3.438 17.416a.623.623 0 01-.313.084z"/>'
  }
})
